import React from 'react'
import { formatDateShort } from '../../../../../../constants/dates'
import { getDv360LineItemDates } from './helpers'

const DatesSectionPreview = ({ lineItem }) => {
  const { startDate, endDate } = getDv360LineItemDates(lineItem)

  const formatStartDate = formatDateShort(startDate)
  const formatEndDate = formatDateShort(endDate)

  return (
    <p>
      {formatStartDate} - {formatEndDate}
    </p>
  )
}

export default DatesSectionPreview
